import React, { useState, useEffect } from 'react';
import { CgClose } from "react-icons/cg";
import { FaCloudUploadAlt } from "react-icons/fa";
import uploadImage from '../helpers/uploadImage';
import { MdDelete } from "react-icons/md";
import SummaryApi from '../common';
import { toast } from 'react-toastify';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';

const UploadAdvertisement = ({ onClose, fetchData }) => {
  const [loading, setLoading] = useState(false); 
  const [data, setData] = useState({
    name :"",
    desktopImage : "",
    mobileImage :"",
    link :""
  });
  const [openFullScreenImage, setOpenFullScreenImage] = useState(false);
  const [fullScreenImage, setFullScreenImage] = useState("");


  const handleOnChange = (e) => {
    const { name, value } = e.target;
  
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleUploadAdvertisement1 = async (e) => {
    const file = e.target.files[0];
    const uploadImageCloudinary = await uploadImage(file);

    setData((prev) => ({
      ...prev,
      desktopImage :  uploadImageCloudinary.url,
    }));
  };

  const handleUploadAdvertisement2 = async (e) => {
    const file = e.target.files[0];
    const uploadImageCloudinary = await uploadImage(file);

    setData((prev) => ({
      ...prev,
      mobileImage : uploadImageCloudinary.url
    }));
  };

  const handleDeleteAdvertisement1 = async () => {

    setData((prev) => ({
      ...prev,
      desktopImage:"",
    }));
  };

  const handleDeleteAdvertisement2 = async () => {

    setData((prev) => ({
      ...prev,
      mobileImage: "",
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true)

    const requestBody = {
      ...data,
    };
    
    const response = await fetch(SummaryApi.uploadAdvertisement.url, {
      method: SummaryApi.uploadAdvertisement.method,
      credentials: 'include',
      headers: {
        "content-type": "application/json"
      },
      body: JSON.stringify(requestBody) 
    });
    
    const responseData = await response.json();

    if (responseData.success) {
      setLoading(false)
      toast.success(responseData?.message);
      onClose();
      fetchData();
    }
    
    if (responseData.error) {
      setLoading(false)
      toast.error(responseData?.message);
    }
  };
  
  

  useEffect(() => {
  }, []);

  return (
    <div className='fixed w-full h-full bg-slate-200 bg-opacity-35 top-0 left-0 right-0 bottom-0 flex justify-center items-center'>
      <div className='bg-white p-4 rounded w-full max-w-2xl h-full max-h-[80%] overflow-hidden'>
        <div className='flex justify-between items-center pb-3'>
        <h2 className='font-bold text-lg text-center w-full'>
        إضافة إعلان جديد
      </h2>
          <div className='w-fit ml-auto text-2xl hover:text-red-600 cursor-pointer' onClick={onClose}>
            <CgClose />
          </div>
        </div>

        <form className='grid p-4 gap-2 overflow-y-scroll h-full pb-5' onSubmit={handleSubmit}>
        <label htmlFor='name'>
  <span className='text-red-500 font-bold mr-1'>*</span>
  اسم الإعلان :
</label>
          <input
            type='text'
            id='name'
            placeholder='ادخل اسم الإعلان'
            name='name'
            value={data.name}
            onChange={handleOnChange}
            className='p-2 bg-slate-100 border rounded'
            required
          />
        
          <label htmlFor='desktopImage' className='mt-3'>
          <span className='text-red-500 font-bold mr-1'>*</span>
            صورة الإعلان(Desktop) :</label>
          <label htmlFor='uploadDesktopImageInput'>
            <div className='p-2 bg-slate-100 border rounded h-32 w-full flex justify-center items-center cursor-pointer'>
              <div className='text-slate-500 flex justify-center items-center flex-col gap-2'>
                <span className='text-4xl'><FaCloudUploadAlt /></span>
                <p className='text-sm'>قم برفع صورة الإعلان</p>
                <input type='file' id='uploadDesktopImageInput' className='hidden' onChange={handleUploadAdvertisement1} />
              </div>
            </div>
          </label>
          <div>
  {data?.desktopImage ? (
    <div className='flex items-center gap-2'>
      <div className='relative group'>
        <img
          src={data.desktopImage}
          alt="Desktop Image"
          width={80}
          height={80}
          className='bg-slate-100 border cursor-pointer'
          required
          onClick={() => {
            setOpenFullScreenImage(true);
            setFullScreenImage(data.desktopImage);
          }}
        />
        <div
          className='absolute bottom-0 right-0 p-1 text-white bg-red-600 rounded-full hidden group-hover:block cursor-pointer'
          onClick={() => handleDeleteAdvertisement1()}
        >
          <MdDelete />
        </div>
      </div>
    </div>
  ) : (
    <p className='text-red-600 text-xs'>*من فضلك اضف صورة الإعلان</p>
    
  )}
</div>



<label htmlFor='mobileImage' className='mt-3'>
          <span className='text-red-500 font-bold mr-1'>*</span>
            صورة الإعلان(mobile) :</label>
          <label htmlFor='uploadMobileImageInput'>
            <div className='p-2 bg-slate-100 border rounded h-32 w-full flex justify-center items-center cursor-pointer'>
              <div className='text-slate-500 flex justify-center items-center flex-col gap-2'>
                <span className='text-4xl'><FaCloudUploadAlt /></span>
                <p className='text-sm'>قم برفع صورة الإعلان</p>
                <input type='file' id='uploadMobileImageInput' className='hidden' onChange={handleUploadAdvertisement2} />
              </div>
            </div>
          </label>
          <div>
  {data?.mobileImage ? (
    <div className='flex items-center gap-2'>
      <div className='relative group'>
        <img
          src={data.mobileImage}
          alt="Mobile Image"
          width={80}
          height={80}
          className='bg-slate-100 border cursor-pointer'
          required
          onClick={() => {
            setOpenFullScreenImage(true);
            setFullScreenImage(data.mobileImage);
          }}
        />
        <div
          className='absolute bottom-0 right-0 p-1 text-white bg-red-600 rounded-full hidden group-hover:block cursor-pointer'
          onClick={() => handleDeleteAdvertisement2()}
        >
          <MdDelete />
        </div>
      </div>
    </div>
  ) : (
    <p className='text-red-600 text-xs'>*من فضلك اضف صورة الإعلان</p>
  )}
</div>


          <label htmlFor='link'>
           الرابط:
            </label>
          <input
            type='text'
            id='link'
            placeholder='ادخل رابط الإعلان'
            name='link'
            value={data.link}
            onChange={handleOnChange}
            className='p-2 bg-slate-100 border rounded'
          />
            <button
            type='submit'
            className={`w-full p-2 text-lg font-medium rounded ${loading ? 'bg-blue-300 cursor-not-allowed' : 'bg-blue-900 hover:bg-blue-700 active:bg-blue-700'} text-white`}
            disabled={loading}
          >
            {loading ? (
              <span className='flex justify-center items-center'>
                <AiOutlineLoading3Quarters/>
                جاري إضافة إعلان جديد...
              </span>
            ) : 'إضافة إعلان جديد'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default UploadAdvertisement;
